'use client'
import {
  useConfig_default
} from "./chunk-AVLZHNEN.mjs";

// src/hooks/useResellConfig.ts
var useResellConfig = () => {
  return useConfig_default().resell || {};
};

export {
  useResellConfig
};
//# sourceMappingURL=chunk-DEQL4QLR.mjs.map